import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Button, Card, Space, Typography } from "antd";
import { CheckCircleOutlined, GlobalOutlined, LinkOutlined, SkinOutlined } from "@ant-design/icons";
import paths from "routes/paths";
import "./OlreadiaFlowPages.css";

const { Paragraph, Text, Title } = Typography;

export default function WebsiteSuccess() {
  const navigate = useNavigate();
  const { websiteId } = useParams();
  const [searchParams] = useSearchParams();
  const previewUrl = searchParams.get("previewUrl") || "";

  return (
    <div className="olreadia-flow-page">
      <main className="olreadia-flow-main">
        <section className="olreadia-flow-hero">
          <span className="olreadia-flow-hero__icon"><CheckCircleOutlined /></span>
          <div>
            <Text className="olreadia-flow-eyebrow">Website ready</Text>
            <Title level={2}>Your website preview is ready</Title>
            <Paragraph>Review the generated site, manage details, or add a custom domain.</Paragraph>
          </div>
        </section>

        <Card className="olreadia-flow-card">
          <Space direction="vertical" size={12} style={{ width: "100%" }}>
            <div className="olreadia-flow-detail-grid">
              <div><Text>Website ID</Text><strong>{websiteId}</strong></div>
              <div><Text>Preview</Text><strong>{previewUrl || "Open from Website Details"}</strong></div>
            </div>
            <div className="olreadia-flow-actions">
              {previewUrl ? <Button type="primary" icon={<LinkOutlined />} href={previewUrl} target="_blank">Open Website</Button> : null}
              <Button icon={<GlobalOutlined />} onClick={() => navigate(paths.website)}>Website Details</Button>
              <Button icon={<SkinOutlined />} onClick={() => navigate(`${paths.websiteRegenerate}?websiteId=${encodeURIComponent(websiteId || "")}`)}>Change Template</Button>
              <Button icon={<GlobalOutlined />} onClick={() => navigate(`${paths.websiteDomain}?websiteId=${encodeURIComponent(websiteId || "")}`)}>Custom Domain</Button>
            </div>
          </Space>
        </Card>
      </main>
    </div>
  );
}
